(() => {
  const init = scope => {
    scope.querySelectorAll('[data-nac-tabs]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const activate = tab => tabs.forEach(button => {
        const active = button === tab;
        button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
        if (panel) panel.hidden = !active;
      });
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {event.preventDefault(); activate(tabs[next]); tabs[next].focus();}
        });
      });
    });
    scope.querySelectorAll('[data-nac-carousel]').forEach(track => {
      if (track.dataset.ready) return;
      track.dataset.ready = 'true';
      const section = track.closest('[data-nac-section]');
      ['prev','next'].forEach(direction => section.querySelector('[data-nac-' + direction + ']')?.addEventListener('click', () => {
        const distance = track.firstElementChild?.getBoundingClientRect().width || track.clientWidth;
        track.scrollBy({left:(direction === 'next' ? 1 : -1) * (distance + 14), behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
      }));
    });
    const product = scope.querySelector('[data-nac-product]');
    const sticky = document.querySelector('[data-nac-sticky]');
    if (product && sticky && !sticky.dataset.ready) {
      sticky.dataset.ready = 'true';
      const buy = product.querySelector('[data-nac-purchase]');
      if (buy) {
        const observer = new IntersectionObserver(() => {sticky.hidden = buy.getBoundingClientRect().bottom > 0;});
        observer.observe(buy);
        document.addEventListener('shopify:section:unload', e => {if(e.target.contains(product)) observer.disconnect();});
      }
      sticky.querySelector('[data-nac-submit]')?.addEventListener('click', () => {
        const button = product.querySelector('product-form-component button[type="submit"]');
        if (button && !button.disabled) button.click();
        else document.querySelector('#nac-achat')?.scrollIntoView({behavior:'smooth'});
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
 const init = () => {
  const main = document.querySelector('[data-uvora-main]');
  if (!main || main.dataset.uvoraReady) return;
  main.dataset.uvoraReady = 'true';
  const sticky = document.querySelector('[data-uvora-sticky]');
  const purchase = main.querySelector('[data-nac-purchase]');
  const original = () => main.querySelector('product-form-component button[type="submit"]');
  document.querySelectorAll('[data-uvora-submit]').forEach(button => {
   button.addEventListener('click', () => {
    const native = original();
    if (native && !native.disabled) native.click();
    else main.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
   });
  });
  if (!sticky || !purchase) return;
  const isVisible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const update = () => {
   const cartOpen = document.querySelector('#cart-drawer dialog[open], #cart-drawer[open], #cart-drawer[data-state="open"]');
   const consent = [...document.querySelectorAll('#shopify-pc__banner,.shopify-pc__banner__dialog')].some(isVisible);
   const mediaControl = [...document.querySelectorAll('video')].some(v=>!v.paused);
   sticky.hidden = purchase.getBoundingClientRect().bottom > 0 || !!cartOpen || consent || mediaControl;
  };
  const observer = new IntersectionObserver(update); observer.observe(purchase);
  const changes = new MutationObserver(update); changes.observe(document.body,{attributes:true,subtree:true,attributeFilter:['open','data-state','aria-hidden','class'],childList:true});
  document.addEventListener('play',update,true);document.addEventListener('pause',update,true);
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(main)){observer.disconnect();changes.disconnect();}});
  update();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
